<template>
  <div v-if="tocList?.length" class="font-medium">
    <h3 class="mb-[20px] text-[20px] leading-[24px]">Содержание</h3>
    <ul
      class="max-h-90 custom-scrollbar list-disc overflow-y-scroll text-[#4d4d4d]"
    >
      <li
        v-for="(item, index) in tocList"
        :key="`toc-item-${item.offset}-${index}`"
        class="mb-[20px] ml-[16px] last:mb-0"
        :class="{
          'text-collection': index === getCurrentActive,
        }"
      >
        <a
          v-smooth-scroll="{
            duration: 1000,
            offset: -80,
            updateHistory: false,
          }"
          :href="`#${item.offset}`"
          @click.prevent="handleClick(`#${item.offset}`)"
        >
          {{ item.title }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
onBeforeRouteUpdate(async () => {
  await calcOffset();
});

const props = defineProps({
  reCalcOffsetCounterFlag: {
    type: Number,
    default: 0,
  },
});

const route = useRoute();
const router = useRouter();
const tocList = ref([]);
const currentOffset = ref(null);

const getCurrentActive = computed(() => {
  let res = 0;
  const offsetArr = tocList.value?.map((item) => item.offset);

  offsetArr.forEach((item, index) => {
    if (
      currentOffset.value >= item &&
      (offsetArr[+index + 1] > currentOffset.value ||
        +index === offsetArr.length - 1)
    ) {
      res = +index;
    }
  });

  return res;
});

watch(
  () => props.reCalcOffsetCounterFlag,
  () => {
    calcOffset();
  },
);

onMounted(async () => {
  await calcOffset();
  window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

const calcOffset = async () => {
  tocList.value = [];
  await nextTick().then(() => {
    const matches = document.querySelectorAll(`.page-body h2`);
    matches.forEach((value) => {
      value.id = value.offsetTop;
      tocList.value.push({
        title: value.textContent,
        offset: value.offsetTop,
        type: value.tagName === 'H2' ? 'h2' : 'h3',
      });
    });
  });
};

const handleScroll = () => {
  // TODO: добавочное значение 1100 выправляет отслеживание прокрутки заголовков, разобраться почему на старой истории это не требовалось
  currentOffset.value = window.pageYOffset - window.outerHeight + 1100;
};

const handleClick = (hash) => {
  setTimeout(() => {
    router.push({ path: route.path, hash });
  }, 800);
};
</script>
